<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <i class="iconfont icon-mima1"></i>
        <span>请设置新密码</span>
      </div>
      <div class="text item">
        <el-form
          label-position="top"
          ref="ruleForm"
          label-width="80px"
          :model="uCenter.password"
          :rules="uCenterPwdRule">
          <el-row>
            <el-col :offset="3" :span="12">
              <el-form-item class="inputText" label="账号">
                <el-input v-model="uCenter.name" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="3" :span="12">
              <el-form-item class="inputText" label="旧密码">
                <el-input v-model="uCenter.password.oldPwd" placeholder="输入旧密码" autocomplete="new-password" :show-password="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="3" :span="12">
              <el-form-item class="inputText" label="新密码" prop="newPwd" ref="newPwd">
                <el-input v-model="uCenter.password.newPwd" id="newPwd" placeholder="输入新密码，长度为10-20位，包含数字、大小写字母和字符" autocomplete="new-password" :show-password="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="3" :span="12">
              <el-form-item class="inputText" label="确认密码" prop="confirmNewPwd" ref="confirmNewPwd">
                <el-input v-model="uCenter.password.confirmNewPwd" placeholder="输入确认新密码" autocomplete="new-password" :show-password="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :offset="3">
            <common-button size="default" :loading="saveLoading" type="primary" image @click="triggerChecked('ruleForm')">确 定</common-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-dialog
      :visible.sync="showSaveVisible"
      width="30%">
      <span>确认修改该账号的密码？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSaveVisible = false" type="info" size="small">取 消</el-button>
        <el-button type="primary" @click="sureSavePassword" :loading="saveLoading" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <animation :loading-data-visible="isLoading" loading-text="加载中"/>
  </div>
</template>

<script>
import * as constantsRules from '@/constants/constantRules'
import {Message} from "element-ui";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import Animation from "../../components/loading/animation";

export default {
  name: "password",
  components: {Animation},
  data() {
    return {
      //显示提示用户操作
      showSaveVisible: false,
      //按钮设置加载中
      saveLoading: false,
      //父组件传过来的数据
      uCenter: {
        name: '',
        password: {
          oldPwd : '',
          newPwd : '',
          confirmNewPwd : '',

        },
      },
      uCenterPwdRule: constantsRules.registerRules1,
      //是否在加载中
      isLoading: false,
    }
  },

  mounted() {
    this.findUserInfo()
  },
  methods: {

    //查询当前用户的数据
    findUserInfo() {
      this.isLoading = true
      let token = cookie.getCookie("token");
      let that = this;
      http.post(window.config.api.baseUrl + '/eims-api/user/currLoginInfo', {
        token: token,
        data: {}
      }).then(response => {
        let userId = response.data.data.userId
        this.uCenter.name = userId

      }).finally(() => {
        this.isLoading = false
      });
    },


    triggerChecked(formName) {
      let flag = false;
      //validate触发检验
      this.$refs[formName].validate((valid) => {
        flag = valid;
      });
      if (!flag) {
        return
      }
      if (this.uCenter.password.newPwd !== this.uCenter.password.confirmNewPwd) {
        Message.error("两次输入的密码不一致")
        return;
      }
      this.showSaveVisible = true
    },

    sureSavePassword() {
      this.saveLoading = true
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          oldPwd: this.uCenter.password.oldPwd,
          newPwd: this.uCenter.password.newPwd,
        }
      }
      http.post(window.config.api.baseUrl + '/eims-api/user/passwordUpdate', obj).then(value => {
        if (value.data.code === '00000') {
          Message.success({message: "密码修改成功", showClose: true})
          this.clearInfo()
        }
      }).finally(() => {
        this.saveLoading = false
        this.showSaveVisible = false;
      })

    },

    clearInfo() {
      this.uCenter.password.confirmNewPwd = ''
      this.uCenter.password.newPwd = ''
      this.uCenter.password.oldPwd = ''

      //点击确定之后去掉校验字眼
      this.$nextTick(()=>{
        this.$refs.newPwd.validateState = ""
        this.$refs.confirmNewPwd.validateState = ""
      })


    }
  }
}
</script>

<style scoped>
/*将el-card的边框去掉*/
/deep/ .el-card {
  border: 0px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/Password.vue